// import React from 'react';
// import * as XLSX from 'xlsx';

// const ExportToExcel = ({ data, languageId, en, ch }) => {
//   const exportToExcel = () => {
//     // Prepare the data for Excel export
//     const excelData = data.map(item => ({
//       [languageId === "1" ? en.Method : ch.Method]: item.method,
//       [languageId === "1" ? en.enabler_ln : ch.enabler_ln]: item.enablers,
//       [languageId === "1" ? en.question : ch.question]: item.questions,
//       [languageId === "1" ? en.desired : ch.desired]: item.desired,
//       [languageId === "1" ? en.Difficulty : ch.Difficulty]: item.currentseq,
//       [languageId === "1" ? en.Importance : ch.Importance]: item.desiredseq,
//       [languageId === "1" ? en.Time : ch.Time]: item.time,
//       [languageId === "1" ? en.remarks : ch.remarks]: item.remarks
//     }));

//     // Create a new workbook
//     const wb = XLSX.utils.book_new();
//     const ws = XLSX.utils.json_to_sheet(excelData);
    
//     // Add the worksheet to the workbook
//     XLSX.utils.book_append_sheet(wb, ws, "Opportunities");
    
//     // Generate the Excel file
//     XLSX.writeFile(wb, "Opportunity_Bubble_Chart_Data.xlsx");
//   };

//   return (
//     <button
//       onClick={exportToExcel}
//       className="bg-green-500 hover:bg-green-600 text-white p-2 rounded text-2xl h-12 flex items-center justify-center"
//       title={languageId === "1" ? "Export to Excel" : "导出到Excel"}
//     >
//       {languageId === "1" ? "Export" : "导出"}
//     </button>
//   );
// };

// export default ExportToExcel;

// import React, { useRef } from 'react';
// import * as XLSX from 'xlsx';
// import html2canvas from 'html2canvas';

// const ExportToExcel = ({ data, languageId, en, ch, chartRef }) => {
//   const exportToExcel = async () => {
//     try {
//       // 1. Convert chart to image
//       const chartElement = document.querySelector('.recharts-wrapper');
//       const canvas = await html2canvas(chartElement);
//       const chartImage = canvas.toDataURL('image/png');

//       // 2. Prepare the data for Excel export
//       const excelData = data.map(item => ({
//         [languageId === "1" ? en.Method : ch.Method]: item.method,
//         [languageId === "1" ? en.enabler_ln : ch.enabler_ln]: item.enablers,
//         [languageId === "1" ? en.question : ch.question]: item.questions,
//         [languageId === "1" ? en.desired : ch.desired]: item.desired,
//         [languageId === "1" ? en.Difficulty : ch.Difficulty]: item.currentseq,
//         [languageId === "1" ? en.Importance : ch.Importance]: item.desiredseq,
//         [languageId === "1" ? en.Time : ch.Time]: item.time,
//         [languageId === "1" ? en.remarks : ch.remarks]: item.remarks
//       }));

//       // 3. Create a new workbook
//       const wb = XLSX.utils.book_new();
//       const ws = XLSX.utils.json_to_sheet(excelData);
      
//       // 4. Add the worksheet to the workbook
//       XLSX.utils.book_append_sheet(wb, ws, "Opportunities");
      
//       // 5. Add chart image to a second sheet
//       const ws2 = XLSX.utils.aoa_to_sheet([]);
//       XLSX.utils.book_append_sheet(wb, ws2, "Chart");
      
//       // 6. Generate the Excel file with image
//       XLSX.writeFile(wb, "Opportunity_Bubble_Chart_Data.xlsx");
      
//       // 7. For the image, we need a different approach since XLSX doesn't directly support images
//       // This is a more advanced implementation that would require using a library like exceljs
//       // For now, we'll just save the image separately
//       const link = document.createElement('a');
//       link.download = 'chart.png';
//       link.href = chartImage;
//       link.click();

//       alert(languageId === "1" 
//         ? "Data exported to Excel and chart saved as PNG" 
//         : "数据已导出到Excel，图表已保存为PNG");

//     } catch (error) {
//       console.error("Export error:", error);
//       alert(languageId === "1" 
//         ? "Error exporting data" 
//         : "导出数据时出错");
//     }
//   };

//   return (
//     <button
//       onClick={exportToExcel}
//       className="bg-green-500 hover:bg-green-600 text-white p-2 rounded text-2xl h-12 flex items-center justify-center"
//       title={languageId === "1" ? "Export to Excel" : "导出到Excel"}
//     >
//       {languageId === "1" ? "Export" : "导出"}
//     </button>
//   );
// };

// export default ExportToExcel;

// import React from 'react';
// import ExcelJS from 'exceljs';
// import html2canvas from 'html2canvas';

// const ExportToExcel = ({ data, languageId, en, ch }) => {
//   const exportToExcel = async () => {
//     try {
//       // 1. Convert chart to image
//       const chartElement = document.querySelector('.recharts-wrapper');
//       const canvas = await html2canvas(chartElement);
//       const chartImage = canvas.toDataURL('image/png').split(',')[1];
      
//       // 2. Create workbook
//       const workbook = new ExcelJS.Workbook();
//       const worksheet = workbook.addWorksheet('Opportunities');
//       const chartWorksheet = workbook.addWorksheet('Chart');

//       // 3. Add headers
//       worksheet.columns = [
//         { header: languageId === "1" ? en.Method : ch.Method, key: 'method' },
//         { header: languageId === "1" ? en.enabler_ln : ch.enabler_ln, key: 'enablers' },
//         { header: languageId === "1" ? en.question : ch.question, key: 'questions' },
//         { header: languageId === "1" ? en.desired : ch.desired, key: 'desired' },
//         { header: languageId === "1" ? en.Difficulty : ch.Difficulty, key: 'currentseq' },
//         { header: languageId === "1" ? en.Importance : ch.Importance, key: 'desiredseq' },
//         { header: languageId === "1" ? en.Time : ch.Time, key: 'time' },
//         { header: languageId === "1" ? en.remarks : ch.remarks, key: 'remarks' }
//       ];

//       // 4. Add data rows
//       data.forEach(item => {
//         worksheet.addRow({
//           method: item.method,
//           enablers: item.enablers,
//           questions: item.questions,
//           desired: item.desired,
//           currentseq: item.currentseq,
//           desiredseq: item.desiredseq,
//           time: item.time,
//           remarks: item.remarks
//         });
//       });

//       // 5. Add image to chart worksheet
//       const imageId = workbook.addImage({
//         base64: chartImage,
//         extension: 'png',
//       });

//       chartWorksheet.addImage(imageId, {
//         tl: { col: 0, row: 0 },
//         ext: { width: 500, height: 500 }
//       });

//       // 6. Generate Excel file
//       const buffer = await workbook.xlsx.writeBuffer();
//       const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//       const link = document.createElement('a');
//       link.href = URL.createObjectURL(blob);
//       link.download = 'Opportunity_Bubble_Chart_Data.xlsx';
//       link.click();
      
//     } catch (error) {
//       console.error("Export error:", error);
//       alert(languageId === "1" 
//         ? "Error exporting data" 
//         : "导出数据时出错");
//     }
//   };

//   return (
//     <button
//       onClick={exportToExcel}
//       className="bg-green-500 hover:bg-green-600 text-white p-2 rounded text-2xl h-12 flex items-center justify-center"
//       title={languageId === "1" ? "Export to Excel" : "导出到Excel"}
//     >
//       {languageId === "1" ? "Export" : "导出"}
//     </button>
//   );
// };

// export default ExportToExcel;

import React from 'react';
import ExcelJS from 'exceljs';
import html2canvas from 'html2canvas';

const ExportToExcel = ({ data, languageId, en, ch, chartRef }) => {
  const exportToExcel = async () => {
    try {
      // 1. Convert chart to image
      const canvas = await html2canvas(chartRef.current);
      const chartImage = canvas.toDataURL('image/png').split(',')[1];
      
      // 2. Create workbook with single worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Opportunities');

      // 3. Add chart image at the top
      const imageId = workbook.addImage({
        base64: chartImage,
        extension: 'png',
      });

      // Add image to worksheet at A1 cell
      worksheet.addImage(imageId, {
        tl: { col: 0, row: 0 },
        ext: { width: 1200, height: 400 } // Adjust size as needed
      });

      // 4. Add 5 empty rows after the chart
      for (let i = 0; i < 20; i++) {
        worksheet.addRow([]);
      }

      // 5. Add headers starting from row 7 (0-based index)
      const headerRow = worksheet.addRow([
        languageId === "1" ? en.QID : ch.QID,
        languageId === "1" ? en.Method : ch.Method,
        languageId === "1" ? en.enabler_ln : ch.enabler_ln,
        languageId === "1" ? en.question : ch.question,
        languageId === "1" ? en.desired : ch.desired,
        languageId === "1" ? en.Difficulty : ch.Difficulty,
        languageId === "1" ? en.Importance : ch.Importance,
        languageId === "1" ? en.Time : ch.Time,
        languageId === "1" ? en.remarks : ch.remarks
      ]);

      // Style the header row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFD3D3D3' } // Light gray background
        };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

      // 6. Add data rows
      data.forEach(item => {
        const row = worksheet.addRow([
          item.qid,
          item.method,
          item.enablers,
          item.questions,
          item.desired,
          item.currentseq,
          item.desiredseq,
          item.time,
          item.remarks
        ]);

        // Add borders to data cells
        row.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        });
      });

      // 7. Auto-fit columns
      worksheet.columns.forEach(column => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, cell => {
          let columnLength = cell.value ? cell.value.toString().length : 0;
          if (columnLength > maxLength) {
            maxLength = columnLength;
          }
        });
        column.width = Math.min(Math.max(maxLength + 2, 10), 50);
      });

      // 8. Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'Opportunity_Bubble_Chart_Report.xlsx';
      link.click();
      
    } catch (error) {
      console.error("Export error:", error);
      alert(languageId === "1" 
        ? "Error exporting data" 
        : "导出数据时出错");
    }
  };

  return (
    <button
      onClick={exportToExcel}
      className="bg-green-500 hover:bg-green-600 text-white p-2 rounded text-2xl h-12 flex items-center justify-center"
      title={languageId === "1" ? "Export to Excel" : "导出到Excel"}
    >
      {languageId === "1" ? "Export" : "导出"}
    </button>
  );
};

export default ExportToExcel;